module.exports = "./img/34fd4ba3b24401974b9025934976777e.jpg";